import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BibliographyList {
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SearchType
  displayMaterialFormat: SystemCode
  displayTitle: string
  sortTitle: string
  displayAuthor: string
  sortAuthor: string
  displayPublisher: string
  sortPublisher: string
  displayPublished: string
  collectionFlag: CollectionFlag
}

export function BibliographyListFromJSON(json: any): BibliographyList {
  return {
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    searchType: exists(json, 'search_type')
      ? json.search_type
      : SearchType.Book,
    displayMaterialFormat: exists(json, 'display_material_format')
      ? SystemCodeFromJSON(json.display_material_format)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    sortPublisher: exists(json, 'sort_publisher') ? json.sort_publisher : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection
  }
}
